import { atom } from 'jotai';

/**
 * Tracks which guards are currently loading
 * Key: guard identifier, Value: boolean (true = loading)
 */
const guardLoadingStatesAtom = atom({});
/**
 * Derived atom - true if ANY guard is loading
 */
const isAnyGuardLoadingAtom = atom((get) => {
    const loadingStates = get(guardLoadingStatesAtom);
    return Object.values(loadingStates).some((isLoading) => isLoading);
});
/**
 * Guard identifiers for consistent naming
 */
var GuardId;
(function (GuardId) {
    GuardId["AUTH"] = "auth";
    GuardId["AUTHORIZATION"] = "authorization";
    GuardId["SESSION_DATA"] = "session-data";
    GuardId["INVITATION"] = "invitation";
})(GuardId || (GuardId = {}));

export { GuardId, guardLoadingStatesAtom, isAnyGuardLoadingAtom };
//# sourceMappingURL=loadingAtoms.js.map
